import { DiEntity, DiEntityIdentifier } from 'core/di/types'
import { DI_TOKENS } from 'shared/constants/di'

import { UsersViewModel } from './users'

export const viewModels: Array<{
  diToken: DiEntityIdentifier
  entity: DiEntity
}> = [{ diToken: DI_TOKENS.usersViewModel, entity: UsersViewModel }]
